import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { PopoverAnchor } from '@radix-ui/react-popover';
import { DocumentCopyIcon } from '@/public/assets/svg';
import { Popover, PopoverContent } from '../Popover';
import { CopyToClipboardProps } from './types';
const CopyToClipboard = ({
  text,
  classNameText,
  classNameIcon,
  className
}: CopyToClipboardProps) => {
  const [isTooltipShowed, setIsTooltipShowed] = useState(false);
  const onClick = () => {
    if (typeof text !== 'string') {
      return null;
    }
    navigator.clipboard.writeText(text);
    setIsTooltipShowed(true);
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsTooltipShowed(false);
    }, 2000);
    return () => {
      clearTimeout(timeout);
    };
  }, [isTooltipShowed]);
  return <Popover open={isTooltipShowed} onOpenChange={open => setIsTooltipShowed(open)} data-sentry-element="Popover" data-sentry-component="CopyToClipboard" data-sentry-source-file="index.tsx">
      <PopoverAnchor asChild data-sentry-element="PopoverAnchor" data-sentry-source-file="index.tsx">
        <button className={clsx('relative flex max-w-full', className)} onClick={onClick} type="button">
          <p className={clsx('truncate', classNameText)}>{text}</p>
          <DocumentCopyIcon className={clsx('flex-shrink-0', classNameIcon)} data-sentry-element="DocumentCopyIcon" data-sentry-source-file="index.tsx" />
        </button>
      </PopoverAnchor>
      <PopoverContent side="top" align="center" className={clsx('rounded-lg bg-white p-2 px-4 shadow-md', {
      'opacity-0': !isTooltipShowed,
      'opacity-100': isTooltipShowed
    })} style={{
      pointerEvents: 'none'
    }} data-sentry-element="PopoverContent" data-sentry-source-file="index.tsx">
        <div className="flex flex-1 items-center justify-center">
          <span className="text-body-8 text-gray-600">Copied!</span>
        </div>
      </PopoverContent>
    </Popover>;
};
export default CopyToClipboard;